import React from "react";
import { useState } from "react";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import { useEffect } from "react";
import { FaMoneyBill1Wave } from "react-icons/fa6";
import { toast } from "react-toastify";
import { CalculateFinalPrice, CalculateFinalPriceForGoals } from "../../utils/metadata/CalculatePrice";
import { GetCampaignBonus } from "../../utils/calculateCommissions/GetCampaignsBonus";
import { GetWebBonus } from "../../utils/calculateCommissions/GetWebBonus";
import { GetIndividualBonusSoftware } from "../../utils/calculateCommissions/GetIndividualBonusSoftware";
import { GetIndividualBonusMkt } from "../../utils/calculateCommissions/GetIndividualBonusMkt";
import { GetSoftwareMetaBonus } from "../../utils/calculateCommissions/GetSoftwareMetaBonus";
import { getStartAndEndOfMonth } from "../../utils/GetDates";

const MetaIndividualComercial = () => {

  const { start, end } = getStartAndEndOfMonth();

  const [loading, setLoading] = useState(false)
  
  const [services, setServices] = useState([])
  const [solutions, setSolutions] = useState([])

  const [sellers, setSellers] = useState([]);
  const [metaComercialList, setMetaComercialList] = useState([]);

  const [rules, setRules] = useState([])

  const montoMinimo = rules.find((r) => r.category === "Individual" )?.fixedGoal

  const [individualRules, setIndividualRules] = useState([])

  const [filterForms, setFilterForms] = useState({
    fechaFiltro: "fechaVenta",
    //fechaFiltro: "createdAt",
    fechaInicio: start,
    fechaFin: end
  })
  
  const getGoals = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/metaIndividualComercial?limit=0`)
      setIndividualRules(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getCommissions = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/reglasComisiones?limit=0`)
      setRules(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?where[activo][equals]=true&limit=0`);
      const sellers = response.data.docs.filter(
        (w) =>
          (w.area.toUpperCase() === "ADMINISTRACION" &&
            w.puesto.toUpperCase() !== "JEFE DE PROYECTOS" &&
            w.puesto.toUpperCase() !== "GERENTE GENERAL") ||
          w.area.toUpperCase() === "COMERCIAL"
      );
      //const sellers = response.data.docs.filter((w) => w.area.toUpperCase() === "ADMINISTRACION" || w.area.toUpperCase() === "COMERCIAL")
      setSellers(sellers);
    } catch (e) {
      return false
    }
  };

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setSolutions(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const fetchMetaComercial = async () => {
    try {
      const responseMeta = await axios.get(`${BACKEND}/api/metaIndividualComercial?sort=createdAt`);
      setMetaComercialList(responseMeta.data.docs);
    } catch (e) {
      return false
    }
  };

  const fetchCotizaciones = async () => {

    const page = 1
    const limit = 0
  
    const baseUrl = `${BACKEND}/api/serviciosCotizaciones`;
    const queryParams = {
      page,
      limit,
      'where[cotizacion.estado][equals]': 'Exito',
      'where[cotizacion.primeraCotizacion][equals]': true,
      // 'where[or][0][servicio.categoria][equals]': 'Web',
      // 'where[or][1][servicio.categoria][equals]': 'ADS',
      // 'where[or][2][servicio.categoria][equals]': 'Software',
    };
  
    let andFilters = [];
  
    // Fecha: agrupar como and[]
    if (filterForms.fechaInicio) {
      andFilters.push({
        [`cotizacion.${filterForms.fechaFiltro}`]: {
          greater_than_equal: new Date(filterForms.fechaInicio).toISOString(),
        }
      });
    }
  
    if (filterForms.fechaFin) {
      andFilters.push({
        [`cotizacion.${filterForms.fechaFiltro}`]: {
          less_than_equal: new Date(filterForms.fechaFin).toISOString(),
        }
      });
    }
  
    // Si hay filtros AND, los agregamos al query
    if (andFilters.length > 0) {
      andFilters.forEach((filter, index) => {
        const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
        const value = Object.values(Object.values(filter)[0])[0];
        queryParams[key] = value;
      });
    }
  
    // Convertimos todo a query string
    const queryString = new URLSearchParams(queryParams).toString();
  
    try {
      setLoading(true)

      const response = await axios.get(`${baseUrl}?${queryString}`);
      setServices(response.data.docs);

    } catch (e) {
      toast.error("Error al cargar los datos: " + e);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchCotizaciones()
    fetchMetaComercial();
    getWorkers();
    getServices()
    getCommissions()
    getGoals()
  }, []);

  useEffect(() => {
    fetchCotizaciones()
  }, [filterForms]);

  return (
    <div className="flex h-screen flex-col gap-12">

      {/* Header */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto">

          <div className="flex items-center gap-4 p-4">
            <FaMoneyBill1Wave className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">Metas individuales</h2>
          </div>

          {/* Fechas */}
          <div className="flex bg-gray-100 mt-0.5 mb-0.5 w-full gap-10">
            <div className="flex w-full justify-between overflow-x-auto">
    
              {/* Fechas */}
              <div className="flex flex-row gap-4 items-center justify-start w-full px-4">
    
                <div className="flex flec-row items-center justify-center gap-2">
                  <label className="block text-xs font-medium text-gray-900">
                    Filtrar por
                  </label>
    
                  <select
                    value={filterForms.fechaFiltro}
                    onChange={(e) =>
                      setFilterForms((prev) => ({
                        ...prev,
                        fechaFiltro: e.target.value,
                      }))
                    }
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                  >
                    <option value={"fechaVenta"}>Fecha venta</option>
                    <option value={"createdAt"}>Fecha de creación</option>
                    <option value={"fechaCotizacionLimite"}>Fecha límite</option>
                  </select>
                </div>
                
                <div className="flex flec-row items-center justify-center gap-2">
                  <label className="block text-xs font-medium text-gray-900">
                    Fecha inicio
                  </label>
    
                  <div className="flex flex-row items-center justify-center gap-4">
                    <input 
                      type="date" 
                      className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                      value={filterForms.fechaInicio}
                      onChange={(e) => setFilterForms((prev) => ({ ...prev, fechaInicio: e.target.value }))}
                    />
                  </div> 
                </div>
                
                <div className="flex flec-row items-center justify-center gap-2">
                  <label className="block text-xs font-medium text-gray-900">
                    Fecha fin
                  </label>
    
                  <div className="flex flex-row items-center justify-center gap-4">
                    <input 
                      type="date" 
                      className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                      value={filterForms.fechaFin}
                      onChange={(e) => setFilterForms((prev) => ({ ...prev, fechaFin: e.target.value }))}
                    />
                  </div> 
                </div>
    
              </div>  
    
            </div>
          </div>    

        </div>
      </div>
      
      {/* Tabla comisiones */}
      <div className="flex flex-col gap-2">
        <span className="text-gray-700 font-semibold px-4">Comisiones</span>
        <div className="relative overflow-x-auto">
          <table className="w-full text-xs text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 text-center uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Comercial
                </th>
                <th scope="col" className="px-6 py-3">
                  Sueldo Fijo
                </th>
                <th scope="col" className="px-6 py-3">
                  Vendió
                </th>
                <th scope="col" className="px-6 py-3">
                  Comision individual campañas
                </th>
                <th scope="col" className="px-6 py-3">
                  Comision individual webs
                </th>
                <th scope="col" className="px-6 py-3">
                  Comision individual software
                </th>
                <th scope="col" className="px-6 py-3">
                  Comisión meta individual
                </th>
                <th scope="col" className="px-6 py-3">
                  Comisión meta software
                </th>
                <th scope="col" className="px-6 py-3 bg-orange-100">
                  Sueldo + comisiones
                </th>
              </tr>
            </thead>
            <tbody>
              {sellers.map((e) => {

                const sueldoBase = e?.sueldo || 0;

                const vendido = services
                .filter((pago) => pago.cotizacion?.cotizador?.id === e.id)
                //.reduce((acc, value) => acc + CalculateFinalPrice(value, solutions), 0)
                .reduce((acc, value) => acc + CalculateFinalPriceForGoals(value, solutions), 0)


                const vendidoSinSoftware = services
                .filter((pago) => pago.cotizacion?.cotizador?.id === e.id && pago.servicio?.id !== "66cfd3fc5a0dab807ba0c2af")
                //.reduce((acc, value) => acc + CalculateFinalPrice(value, solutions), 0)
                .reduce((acc, value) => acc + CalculateFinalPriceForGoals(value, solutions), 0)


                // const vendidoSoftware = services
                // .filter((pago) => pago.cotizacion?.cotizador?.id === e.id && pago.servicio?.id === "66cfd3fc5a0dab807ba0c2af")
                // .reduce((acc, value) => acc + CalculateFinalPrice(value, solutions), 0)

                const sueldoComisionMkt = GetIndividualBonusMkt(vendidoSinSoftware, individualRules) || 0;

                const campaignBonus = vendidoSinSoftware >= montoMinimo ? GetCampaignBonus(
                  services.filter((s) => s.servicio?.categoria === "ADS" && s.cotizacion?.cotizador?.id === e.id),
                  rules,
                  solutions
                ) : 0;

                const webBonus = vendidoSinSoftware >= montoMinimo ? GetWebBonus(
                  services.filter((s) => s.servicio?.categoria === "Web" && s.cotizacion?.cotizador?.id === e.id),
                  rules,
                  solutions
                ) : 0;

                const softwareIndividual = GetIndividualBonusSoftware(
                  services.filter((s) => s.servicio?.categoria === "Software" && s.cotizacion?.cotizador?.id === e.id),
                  rules,
                  solutions
                )

                const softwareMeta = GetSoftwareMetaBonus(
                  services.filter((s) => s.servicio?.categoria === "Software" && s.cotizacion?.cotizador?.id === e.id),
                  rules,
                  solutions
                )

                return (
                <tr
                  key={e.id}
                  className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700"
                >
                  {/* Nombre vendedor */}
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    {e.name}
                  </th>
                  
                  {/* Sueldo base */}
                  <td className={`px-6 py-4 text-black truncate`}>
                    {sueldoBase.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>

                  {/* Vendió */}
                  <td className={`px-6 py-4 ${vendido > 0 ? "text-black" : "text-gray-200"} truncate`}>
                    S/. {" "}{vendido.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>
                  
                  {/* % Comision individual campañas */}
                  <td className={`px-6 py-4 ${campaignBonus > 0 ? "text-black" : "text-gray-200"} truncate`}>
                    S/. {" "}{campaignBonus.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}                  
                  </td>

                  {/* % Comision individual webs */}
                  <td className={`px-6 py-4 ${webBonus > 0 ? "text-black" : "text-gray-200"} truncate`}>
                    S/. {" "}{webBonus.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}                  
                  </td>

                  {/* % Comision individual software */}
                  <td className={`px-6 py-4 ${softwareIndividual > 0 ? "text-black" : "text-gray-200"} truncate`}>
                    S/. {softwareIndividual.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>

                  {/* Comisión del mes Marketing y Webs */}
                  <td className={`px-6 py-4 ${sueldoComisionMkt > 0 ? "text-black" : "text-gray-200"} truncate`}>
                    S/. {" "}{sueldoComisionMkt.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}                  
                  </td>
                  
                  {/* Comisión del mes Software */}
                  <td className={`px-6 py-4 ${softwareMeta > 0 ? "text-black" : "text-gray-200"} truncate`}>                 
                    S/. {softwareMeta.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>

                  {/* Sueldo final */}
                  <td className={`px-6 py-4 text-black`}>
                    S/. {" "}
                    {(sueldoBase + campaignBonus + webBonus + softwareIndividual + softwareMeta + sueldoComisionMkt).toFixed(2)}                  
                  </td>
                </tr>
                )}
              )}
            </tbody>
          </table>
        </div>
      </div>
      
      {/* Tabla metas individuales */}
      <div className="flex flex-col gap-2">
        <span className="text-gray-700 font-semibold px-4">Metas individuales</span>
        <div className="relative overflow-x-auto">
          <table className="w-full text-xs text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Nombre
                </th>
                <th scope="col" className="px-6 py-3">
                  Meta
                </th>
                <th scope="col" className="px-6 py-3">
                  % Comisión
                </th>
              </tr>
            </thead>
            <tbody>
              {metaComercialList.map((e) => (
                <tr
                  key={e.id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    {e.name}
                  </th>
                  <td className="px-6 py-4">
                    S/ {e?.meta.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>

                  <td className=" px-6 py-4">% {e?.metaPorcentaje}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      {/* Tabla metas software */}
      <div className="flex flex-col gap-2">
        <span className="text-gray-700 font-semibold px-4">Metas software</span>
        <div className="relative overflow-x-auto">
          <table className="w-full text-xs text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Nombre
                </th>
                <th scope="col" className="px-6 py-3">
                  Meta
                </th>
                <th scope="col" className="px-6 py-3">
                  Comisión
                </th>
              </tr>
            </thead>
            <tbody>
              {rules.filter((r) => r.category === "Software" && !r.percentage).map((r) => (
                <tr
                  key={r.id}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    {r.name}
                  </th>
                  <td className="px-6 py-4">
                    S/. {r?.fixedGoal.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>

                  <td className=" px-6 py-4">
                    S/. {r?.fixedCommission.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
   
    </div>
  );
};

export default MetaIndividualComercial;